import { logCollection } from './tables/logCollection';
import { performanceList, performanceMetrics } from './tables/performanceList';
import { logMetricManage } from './tables/logMetricManage';
import { eventPolicy } from './tables/eventPolicy';
import { eventFiltering } from './tables/eventFiltering';
import { eventStatus } from './tables/eventStatus';
import { logSetup } from './tables/logSetup';
import { eventAlert } from './tables/eventAlert';

export const DEFAULT_COLUMN_KEY = 'columns';
export const DEFAULT_METRIC_KEY = 'metric';

export const TableKeys = {
  PerformanceList: 'performance_list',
  LogMetricManage: 'log_metric_manage',
  LogCollection: 'log_collection',
  EventPolicy: 'event_policy',
  EventStatus: 'event_status',
  LogSetup: 'log_setup',
  EventFiltering: 'event_filtering',
  EventAlert: 'event_alert'
};

// product_type_key_A, product_type_key_B call specifier in this scenario
// Set specifiers allow config multiple headers in same table key
// Example of using specifiers, it can be product type or something.
export const ColumnsConfig = {
  [TableKeys.PerformanceList]: {
    [DEFAULT_COLUMN_KEY]: performanceList,
    [DEFAULT_METRIC_KEY]: performanceMetrics,
    // product_type_key_A: {
    //   [{column_config_1}, {column_config2}]
    // }
    // product_type_key_B: {
    //   [{column_config_1}, {column_config2}]
    // }
  },
  [TableKeys.LogMetricManage]: {
    [DEFAULT_COLUMN_KEY]: logMetricManage
  },
  [TableKeys.LogCollection]: {
    [DEFAULT_COLUMN_KEY]: logCollection
  },
  [TableKeys.EventPolicy]: {
    [DEFAULT_COLUMN_KEY]: eventPolicy
  },
  [TableKeys.EventFiltering]: {
    [DEFAULT_COLUMN_KEY]: eventFiltering
  },
  [TableKeys.EventStatus]: {
    [DEFAULT_COLUMN_KEY]: eventStatus
  },
  [TableKeys.LogSetup]: {
    [DEFAULT_COLUMN_KEY]: logSetup
  },
  [TableKeys.EventAlert]: {
    [DEFAULT_COLUMN_KEY]: eventAlert
  }
};
